import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { EdifactSegmentSuffix } from '../models/edifact-segment-suffix';
import { EdifactCharacterSet } from '../models/edifact-character-set';
import { EdifactSyntax } from '../models/edifact-syntax';
import { EdiConfig } from '../models/edifact-config';

import { JsonHttpService } from '../../shared/http/json-http.service';

@Injectable({
    providedIn: 'root'
})
export class EdifactConfigService {


    constructor(private httpService: JsonHttpService) { }

    /**
     * Get the available edifact-character-sets
     */
    getCharacterSets(): Promise<EdifactCharacterSet[]> {
        return this.httpService.get('/api/partners/ediconfig/get-character-sets').toPromise();
    }

    /**
     * Get the available edifact-syntaxes
     */
    getSyntaxes(): Promise<EdifactSyntax[]> {
        return this.httpService.get('/api/partners/ediconfig/get-syntaxes').toPromise();
    }

    /**
     * Gets the available edifact-segment-suffixes
     */
    getEdifactSegmentSuffixes(): Promise<EdifactSegmentSuffix[]> {
        return this.httpService.get('/api/partners/ediconfig/get-segment-suffixes').toPromise();
    }

    /**
     * Saves the given edifact config
     * @param config The configuration to save
     */
    saveEdifactConfig(config: EdiConfig, partnerId: number): Promise<EdiConfig> {
        const options = { params: new HttpParams().set('partnerId', `${partnerId}`) };
        return this.httpService.post('/api/partners/ediconfig/save', config, options).toPromise();
    }
}
